import React, { useState, useCallback } from "react";
import IconClose from "../../../assets/cross-icon.svg";
import { Image } from "react-bootstrap";

export function SortBy({ sortBy = [], onChangeSort }) {
  const [sortStatusToggle, setState] = useState(false);

  return (
    <div
      className={`dropdown field-sort ${sortStatusToggle ? "visible" : ""}`}
      onClick={() => setState(!sortStatusToggle)}
    >
      <div
        className={`dropdown-overlay ${sortStatusToggle ? "visible" : ""}`}
      />
      <div className="dropdown-selected-value">Sort</div>
      <div className="dropdown-option-list hidden-mobile">
        <div className="dropdown-option-list-heading">
          <div className="list-sort">Sort By</div>
          <Image src={IconClose} alt="Close Icon" />
        </div>
        {sortBy
          ? sortBy.map(value => {
              return (
                <div
                  onClick={e => {
                    onChangeSort(value);
                  }}
                >
                  {value.name}
                </div>
              );
            })
          : null}
      </div>
    </div>
  );
}
